import { BrandAndFooter, TrackingConfig } from '~/types/TrackingSettings';
import { ActionKeys } from './constants';

export function fetchTrackingConfig() {
  return <const>{
    type: ActionKeys.FETCH_TRACKING_CONFIG,
  };
}

export function fetchTrackingConfigSuccess(data: TrackingConfig) {
  return <const>{
    type: ActionKeys.FETCH_TRACKING_CONFIG_SUCCESS,
    payload: data,
  };
}

export function fetchTrackingConfigError(error: string) {
  return <const>{
    type: ActionKeys.FETCH_TRACKING_CONFIG_ERROR,
    payload: { error },
  };
}

export function updateTrackingConfig(payload: TrackingConfig) {
  return <const>{
    type: ActionKeys.UPDATE_TRACKING_CONFIG,
    payload,
  };
}

export function updateTrackingConfigSuccess(payload: TrackingConfig) {
  return <const>{
    type: ActionKeys.UPDATE_TRACKING_CONFIG_SUCCESS,
    payload,
  };
}

export function updateTrackingConfigError(error: string) {
  return <const>{
    type: ActionKeys.UPDATE_TRACKING_CONFIG_ERROR,
    payload: { error },
  };
}

export function updateBrandAndFooter(payload: BrandAndFooter) {
  return <const>{
    type: ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS,
    payload,
  };
}

export function updateBrandAndFooterSuccess(payload: BrandAndFooter) {
  return <const>{
    type: ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS_SUCCESS,
    payload,
  };
}

export function updateBrandAndFooterError(error: string) {
  return <const>{
    type: ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS_ERROR,
    payload: { error },
  };
}

export type TrackingSettingsActions =
  | ReturnType<typeof fetchTrackingConfig>
  | ReturnType<typeof fetchTrackingConfigSuccess>
  | ReturnType<typeof fetchTrackingConfigError>
  | ReturnType<typeof updateTrackingConfig>
  | ReturnType<typeof updateTrackingConfigSuccess>
  | ReturnType<typeof updateTrackingConfigError>
  | ReturnType<typeof updateBrandAndFooter>
  | ReturnType<typeof updateBrandAndFooterSuccess>
  | ReturnType<typeof updateBrandAndFooterError>;
